import { apiClient } from "../api/apiClient";

import {
  ApiResponse,
  Coupon,
  CreateCouponRequest,
  UpdateCouponRequest
} from "../interfaces/Coupon";

// ======================================
// COUPON SERVICE
// ======================================

export const couponService = {

  // ======================================
  // GET ALL
  // ======================================

  getAll: async (): Promise<Coupon[]> => {

    const response =
      await apiClient.get<
        ApiResponse<Coupon>
      >(
        "/Coupons/GetAll"
      );

    const result =
      response.data;

    console.log(
      "Coupon Data List:",
      result.dataList
    );

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.dataList || [];
  },

  // ======================================
  // GET ACTIVE ALL
  // ======================================

  getActiveAll: async (): Promise<Coupon[]> => {

    const response =
      await apiClient.get<
        ApiResponse<Coupon>
      >(
        "/Coupons/GetActiveAll"
      );

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.dataList || [];
  },

  // ======================================
  // GET BY ID
  // ======================================

  getById: async (
    id: number
  ): Promise<Coupon> => {

    const response =
      await apiClient.get<
        ApiResponse<Coupon>
      >(
        `/Coupons/${id}`
      );

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    if (!result.data) {

      throw new Error(
        "Coupon not found"
      );
    }

    return result.data;
  },

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: CreateCouponRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "CouponCode",
      payload.couponCode
    );

    formData.append(
      "DiscountType",
      payload.discountType
    );

    formData.append(
      "DiscountValue",
      payload.discountValue.toString()
    );

    formData.append(
      "MinOrderAmount",
      payload.minOrderAmount?.toString() || "0"
    );

    formData.append(
      "MaxUses",
      payload.maxUses?.toString() || "0"
    );

    formData.append(
      "ExpiryDate",
      payload.expiryDate || ""
    );

    formData.append(
      "DisplayOrder",
      payload.displayOrder?.toString() || "0"
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    formData.append(
      "IsFeatured",
      payload.isFeatured?.toString() || "false"
    );

    formData.append(
      "IsActive",
      payload.isActive.toString()
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "OgImage",
      payload.ogImage || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    const response =
      await apiClient.post(
        "/Coupons/Create",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // UPDATE
  // ======================================

  update: async (
    payload: UpdateCouponRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "CouponID",
      payload.couponID.toString()
    );

    formData.append(
      "CouponCode",
      payload.couponCode
    );

    formData.append(
      "DiscountType",
      payload.discountType
    );

    formData.append(
      "DiscountValue",
      payload.discountValue.toString()
    );

    formData.append(
      "MinOrderAmount",
      payload.minOrderAmount?.toString() || "0"
    );

    formData.append(
      "MaxUses",
      payload.maxUses?.toString() || "0"
    );
    

    formData.append(
      "ExpiryDate",
      payload.expiryDate || ""
    );

    formData.append(
      "DisplayOrder",
      payload.displayOrder?.toString() || "0"
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    formData.append(
      "IsFeatured",
      payload.isFeatured?.toString() || "false"
    );

    formData.append(
      "IsActive",
      payload.isActive.toString()
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "OgImage",
      payload.ogImage || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    const response =
      await apiClient.put(
        "/Coupons/Update",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // DELETE
  // ======================================

  delete: async (
    id: number
  ) => {

    const response =
      await apiClient.delete(
        `/Coupons/${id}`
      );

    return response.data;
  }
};